import React from "react"
import { useSelector, useDispatch } from "react-redux"

import Images from "assets/images"
import { VIEW } from "const"
import { MtAccount } from "server/models"
import { mtAccountsRoute } from "client/parts/routes"
import {
    StoreType,
    PackageAlmostExpireTime,
    addModal,
} from "client/store"
import {
    Logo,
    Expired,
    Link,
    DateFormatterString,
    DateFormatter,
    TableColumn,
} from "client/components"

const accountHref = (account: MtAccount) => `${mtAccountsRoute}/${VIEW}/${account.id}`

const packageAlmostExpireTime = PackageAlmostExpireTime()
const now = new Date().getTime()

const Columns = () => {
    const packageList = useSelector((state: StoreType) => state.package.packageList)
    const accountPackageList = useSelector((state: StoreType) => state.accountPackage.accountPackageList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()


    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "logo",
            header: lang.logo,
            centerAlign: true,
            formatter: (account: MtAccount) => {
                const href = accountHref(account)
                return (
                    <Link
                        href={href}
                        onClick={() => dispatch(addModal({ url: href }))}
                    >
                        <Logo table logo={account.logo || Images.accountLogo} />
                    </Link>
                )
            },
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "250px",
            cellMaxWidth: "500px",
            formatter: (account: MtAccount) => {
                const href = accountHref(account)
                let demo = null
                if (account.demoExpiry !== null) {
                    const expiryDate = new Date(account.demoExpiry).getTime()
                    demo = ((expiryDate - now) < 0) ? lang.demoExpired : lang.demo
                }
                return (
                    <>
                        <Link
                            href={href}
                            onClick={() => dispatch(addModal({ url: href }))}
                        >
                            {account.shortName ? `${account.name} (${account.shortName})` : account.name}
                        </Link>
                        {demo && <Expired>{demo}</Expired>}
                    </>
                )
            },
        },
        {
            field: "url",
            header: lang.url,
            sortable: true,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
            formatter: (account: MtAccount) => {
                const href = account.url.indexOf("http") === 0 ? account.url : `http://${account.url}`
                return <a href={href} target="_blank" rel="noreferrer">{account.url}</a>
            },
        },
        {
            field: "package",
            header: lang.package,
            cellMinWidth: "150px",
            formatter: (account: MtAccount) => {
                if (
                    account.id === 1
                    || !accountPackageList
                    || !accountPackageList[account.id]
                    || !accountPackageList[account.id].length
                    || !packageList
                ) return null

                const accountPackages = accountPackageList[account.id]
                const packageState = accountPackages[0]
                const activePackage = packageList[packageState.packageId]
                const packageExpireDate = new Date(packageState.dateEnd)
                const packageExpireTime = packageExpireDate.getTime()

                const almostExpired = packageExpireTime > now && packageExpireTime - now <= packageAlmostExpireTime
                const expired = packageExpireTime <= now
                const formattedDate = DateFormatterString(packageExpireDate, lang)

                return (
                    <>
                        {activePackage.name}
                        { expired && <Expired>{lang.expiredOn.replace("{0}", formattedDate.date)}</Expired> }
                        { almostExpired && <Expired>{lang.expiresOn.replace("{0}", formattedDate.date)}</Expired> }
                    </>
                )
            },
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (account: MtAccount) => <DateFormatter date={account.createdAt} />,
        },
        {
            field: "status",
            header: lang.status,
            centerAlign: true,
            sortable: true,
            editAccess: () => true,
        },
    ]

    return columns
}
export default Columns
